import moment from 'moment-timezone';
import { ORDER_STATUSES, ORDER_TYPES } from 'utils/order/constants';
import { ORDER_STOP_STATUSES } from 'utils/orderStop/constants';

const DRIVER_ETA_IS_DELAYED_MINUTES = 5;
const DRIVER_ETA_MAX_MINUTES_REMAINING_TO_FINISH = 60;

const inProgressStop = (stop) =>
  stop.status === ORDER_STOP_STATUSES.IN_PROGRESS;
const getStopInProgress = (stops) => stops?.find(inProgressStop);
const getIndexOfStopInProgress = (stops) => stops?.findIndex(inProgressStop);

const getShipmentStatus = ({ journeyType, shipments, stops }) => {
  if (journeyType === ORDER_TYPES.SINGLE_SHIPMENT) {
    return shipments?.[0]?.status;
  }
  const stopInProgress = getStopInProgress(stops);
  const shipmentStatuses = Object.values(stopInProgress?.shipments || {});
  return shipmentStatuses[0];
};

const getMinutesRemainingToFinishStop = (stop) => {
  const { time_to: time = '', time_to_tz: tz = '' } = stop || {};
  const now = moment().tz(tz);
  const timeTo = moment(time).tz(tz);
  return timeTo.diff(now, 'minutes');
};

const checkIfNeedsToGetEta = (order) => {
  if (order?.status !== ORDER_STATUSES.IN_TRANSIT) {
    return false;
  }
  const stopInProgress = getStopInProgress(order?.stops);
  if (!stopInProgress) {
    return false;
  }
  return (
    getMinutesRemainingToFinishStop(stopInProgress) <=
    DRIVER_ETA_MAX_MINUTES_REMAINING_TO_FINISH
  );
};

const roundUpMinutes = (momentObject) => {
  const minutesRounded = Math.ceil(momentObject.minutes() / 5) * 5;
  return momentObject.set('minute', minutesRounded);
};

const formatTimeToRoundedHourRange = (momentObject) => {
  if (typeof momentObject !== 'object') return '';

  const timeObject = roundUpMinutes(momentObject);
  const minHourRange = timeObject.format('HH:mm');
  const maxHourRange = timeObject.add({ minutes: 10 }).format('HH:mm');

  return `${minHourRange} - ${maxHourRange}`;
};

const driverIsDelayed = ({ eta, timeTo }) => {
  if (typeof eta !== 'object' || typeof timeTo !== 'object') {
    return false;
  }
  const time = timeTo.add(DRIVER_ETA_IS_DELAYED_MINUTES, 'minutes');
  return eta.isAfter(time);
};

export {
  driverIsDelayed,
  formatTimeToRoundedHourRange,
  checkIfNeedsToGetEta,
  getShipmentStatus,
  getIndexOfStopInProgress,
  getStopInProgress,
};
